import React, {useEffect} from 'react';

import {DocumentUtils} from "../../../Utils";
import {service as StreamBankAuthService} from "../../../Services/StreamBankAuthService";

export const LogoutPage = props => {
    useEffect(() => {
        const redirectUrl = DocumentUtils.GetQueryStringParameter("redirectUrl");
        let loginUrl = '/login';

        if (redirectUrl) {
            loginUrl += `?redirectUrl=${redirectUrl}`;
        }

        StreamBankAuthService.Logout();
        DocumentUtils.changePage(loginUrl);
    }, []);

    return null;
};


